import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../services/utils.service';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { EmojiServiceService } from '../services/emoji-service.service';
import { SwiperComponent } from 'ngx-useful-swiper';
import { LocaleService } from '../services/locale.service';
import { MobileAppService } from '../services/mobile-app.service';
import { LocationService } from '../services/location.service';
import Noty from 'noty';
import { StorageService } from '../services/storage.service';
declare var MobileDetect;

@Component({
  selector: 'app-museum-onboarding',
  templateUrl: './museum-onboarding.component.html',
  styleUrls: ['./museum-onboarding.component.scss']
})

export class MuseumOnboardingComponent implements OnInit {
  @ViewChild('usefulSwiper',{static: false}) usefulSwiper: SwiperComponent;
  coords;
  bgColor;
  reconnectActive = true;
  isLocation = false;
  pageConfig = {
    loginStep: 0,
    loaders: {
      joinGame: false

    }
  };
  noty;
  params;
  swiperConfig = {
    spaceBetween: 10,
    loop: false,
    initialSlide: 2,
    slidesPerView: 'auto',
    loopedSlides: 2,
    centeredSlides: true
  };
  activeGame;
  error;
  playerObj = {
    teamName: null,
    avatarIndex: 0,
    passedQuests: []
  };
  locales = {
    reconnect: '',
  };

  constructor(public utilsService: UtilsService, private route: ActivatedRoute, private http: HttpClient, private router: Router, public emojiService: EmojiServiceService, public localeService: LocaleService, private mobileAppService: MobileAppService, private locationService: LocationService, private ngZone: NgZone, private storageService: StorageService) {
    this.detectLocale();
  }

  /** URL prefix e.g. /nl/ must match LocaleService so getTrans() uses the right language. */
  detectLocale() {
    if (window.location.href.indexOf('/hu/') !== -1) {
      this.localeService.locale = 'hu';
    } else if (window.location.href.indexOf('/de/') !== -1) {
      this.localeService.locale = 'de';
    } else if (window.location.href.indexOf('/nl/') !== -1) {
      this.localeService.locale = 'nl';
    } else if (window.location.href.indexOf('/fr/') !== -1) {
      this.localeService.locale = 'fr';
    } else if (window.location.href.indexOf('/es/') !== -1) {
      this.localeService.locale = 'es';
    } else {
      this.localeService.locale = 'en';
    }
    this.locales = {
      reconnect: this.localeService.getTrans('Reconnect'),
    };
  }

  dropNoty(type, text, timeout?) {
    this.noty = new Noty({
      type: type,
      text: text,
      killer: true,
      timeout
    }).show();
  }

  joinGame(){
    this.pageConfig.loaders.joinGame = true;
    console.log(this.activeGame)

    if(this.activeGame.isDynamicQuestionCreation){
      this.dropNoty('info', this.localeService.getTrans('Checking location data') + '<i class="las la-circle-notch ml-1 la-spin"></i>');
      this.locationService.getPosition().then((x: any)=>{
        this.ngZone.run(() => {
            if(x.coords){
              this.coords = x.coords;
              this.isLocation = true;
              this.performJoin(true);
            }    
            if(this.noty){
              this.noty.close();
            }
          });
      }, (err)=>{
        this.isLocation = false;
        this.pageConfig.loaders.joinGame = false;
        Swal.fire({
          title: this.localeService.getTrans('Cannot access location'),
          text: this.localeService.getTrans('You need to grant access to the browser to start the game.'),
          icon: 'error',
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: this.localeService.getTrans(`Got it`),
          cancelButtonText: 'Back',
          heightAuto: false
        });
      
      })
    } else{
      this.performJoin(false);
    }


   
  }

  getMobileDetails(){

    const md = new MobileDetect(window.navigator.userAgent)

    let mobileObj = {
      browser: md.os(),
      isIphone: md.is('iPhone'),
      phone: md.phone(),
      version: md.versionStr('Build')
    }
    return mobileObj;
   
  }

  performJoin(hasLocation?){

    if(!this.params.groupId){
      this.utilsService.dropSwal(this.localeService.getTrans('Oops'), this.localeService.getTrans('Something went wrong or the link is broken'), 'error')
      return;
    }

    this.params = { ...this.params }; // clone it first

    if (!this.params.limit || this.params.limit === undefined || this.params.limit === '0') {
      this.params.limit = 0;
    }


    this.http.post(environment.baseUrl + 'games/countGamesByGroupIdAndPlayer', { groupId: this.params.groupId, playername: this.playerObj.teamName.trim(), limit: this.params.limit}).subscribe((valid: any) => {
      if(valid && valid.success){
        this.playerObj.teamName = this.playerObj.teamName.trim();
        return this.http.post(environment.baseUrl + 'games/joinGameWithQr', { tourId: this.params.tid,
          paymentIdentifier: this.params.pc,
          isShowCase: this.params.showcase === 'true' ? true : false,
          mobileData: this.getMobileDetails(),
          partner: this.params.uid, playerObj: this.playerObj, coords: hasLocation ? {
            lat: this.coords.latitude,
            lng: this.coords.longitude
          } : null }).subscribe((data: any) => {
    
          if(data.success){
            let gameData = {g: data.data._id, p: this.playerObj.teamName, partner: this.params.uid, showcase: this.params.showcase};
            this.storageService.writeStorage('fl_storage', JSON.stringify(gameData));
            this.router.navigate(['/museum-walkthrough', gameData])
          } else{
            this.utilsService.dropSwal(this.localeService.getTrans('Oops'), this.localeService.getTrans('Something went wrong or the link is broken'), 'error')
          }
    
          this.pageConfig.loaders.joinGame = false;
        });
      } else{
        this.pageConfig.loaders.joinGame = false;
        this.utilsService.dropSwal(this.localeService.getTrans('Oops'), this.localeService.getTrans('Player limit reached. However, if you want to rejoin a game, please make sure you use the exact same team name you used before.'), 'error')
      }
    
    }, (err) => {
      this.pageConfig.loaders.joinGame = false;
    });


   
  }

  setAvatar(){
    this.playerObj.avatarIndex = this.usefulSwiper.swiper.activeIndex;
  }

  setAvatarIndex(){
    this.playerObj.avatarIndex = this.usefulSwiper.swiper.activeIndex;
  }

  reconnectToGame(){
    const stored = this.storageService.getStorage('fl_storage');
    if (!stored?.g || !stored?.p) {
      return;
    }
    this.router.navigate(['/game', { g: stored.g, p: stored.p, showcase: stored.showcase }]);
  }

  ngOnInit() {
    if (this.utilsService.checkDeviceCompatibility()) {
      this.route.queryParams.subscribe((params) => {
        this.params = params;
        if (!params.uid) {
          window.location.href = this.mobileAppService.getURL()+'en/museums';
        }

        if(!params.groupId){
          this.utilsService.dropSwal('Oops', 'Something went wrong or the QR was already used before.', 'error')
        }
     
        if (params.pc && params.uid && params.tid) {
         
          return this.http
            .post(
              environment.baseUrl + 'partnerPayments/getPartnerPayment',
              {
                tourId: params.tid,
                paymentIdentifier: params.pc,
                partner: params.uid,
              }
            )
            .subscribe((data: any) => {
              console.log(data);
              if (!data.success) {
                Swal.fire({
                  icon: 'info',
                  text: data.msg,
                  showDenyButton: false,
                  showCancelButton: false,
                  showConfirmButton: true,
                  confirmButtonText: this.localeService.getTrans(`Got it`),
                  confirmButtonColor: '#4E3B74',
                }).then((result) => {
                  this.router.navigate(['/museum-onboarding'], {
                    queryParams: {
                      uid: params.uid,
                    },
                   });
                })
              } else{
                this.activeGame = data.tour;
                this.bgColor = this.utilsService.resolveBrandColor(
                  this.activeGame.partner,
                  this.activeGame
                );
                console.log('Museum Onboarding - bgColor:', this.bgColor);

              }
            });
        }
      });
    }
    if(this.storageService.getStorage('fl_storage')){
        this.reconnectActive = true;
    } else{
      this.reconnectActive = false;
    }
  }

}
